import { render } from "./image-preview.vue?vue&type=template&id=5139e75c"
import script from "./image-preview.vue?vue&type=script&lang=js"
export * from "./image-preview.vue?vue&type=script&lang=js"

import "./image-preview.vue?vue&type=style&index=0&id=5139e75c&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__